import { jsxs, jsx } from "react/jsx-runtime";
import Skeleton from "antd/es/skeleton/Skeleton";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './CarCard.css';import '../Grid/Grid.css';/* empty css                */
/* empty css             */
const CarCardTitleSkeleton = ({
  className,
  active = true
}) => {
  return /* @__PURE__ */ jsxs(Row, { className: classnames("perxis-auto-car-card-title", className), gutter: [0, "vertical-purple"], children: [
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Skeleton.Input, { block: true, active, className: classnames("perxis-auto-car-card-title__skeleton-title") }) }),
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(
      Skeleton.Input,
      {
        block: true,
        active,
        size: "small",
        className: classnames("perxis-auto-car-card-title__skeleton-description")
      }
    ) })
  ] });
};
export {
  CarCardTitleSkeleton as default
};
//# sourceMappingURL=CarCardTitleSkeleton.js.map
